import { merge } from 'lodash';

import getProps from './getProps';

const theme = process.env.REACT_APP_THEME || 'edlen';

const PROPS = {
  BJCC: 'BJCC',
  CAJUN: 'CAJUN',
  EDLEN: 'EDLEN',
  DEV: 'DEV',
  TEST: 'TEST',
  TRAIN: 'TRAIN',
};

// Default site objects, to use for each host
const BJCC = {
  owner: 'BJCC',
  theme: 'BJCC',
  props: getProps(PROPS.BJCC),
};

const CAJUN = {
  owner: 'Cajun',
  theme: 'Cajun',
  props: getProps(PROPS.CAJUN),
};

const EDLEN = {
  owner: 'Edlen',
  theme: 'Edlen',
  props: getProps(PROPS.EDLEN),
};

const DEV = {
  owner: 'Edlen',
  theme: 'EdlenDev',
  props: getProps(PROPS.EDLEN),
};

const TEST = {
  owner: 'Edlen',
  theme: 'EdlenTest',
  props: getProps(PROPS.TEST),
};

const TRAIN = {
  owner: 'Edlen',
  theme: 'EdlenTrain',
  props: getProps(PROPS.TEST),
};

const ENV = {
  PROD: 'production',
  TEST: 'test',
  DEV: 'development',
  //PROD2022: 'production'
};

const SITE = {
  // Cajundome
  'cajundomeordering.com': merge({}, CAJUN, { env: ENV.PROD }),
  'cajun2022.edlen.com': merge({}, CAJUN, { env: ENV.PROD }),
  'cdootest.edlen.com': merge({}, CAJUN, {
    theme: 'cajun-test',
    props: getProps(PROPS.CAJUN, true),
    env: ENV.TEST,
  }),
  'cdootrain.edlen.com': merge({}, CAJUN, {
    props: getProps(PROPS.CAJUN, true),
    env: ENV.TEST,
  }),

  // BJCC
  'bjccordering.edlen.com': merge({}, BJCC, { env: ENV.PROD }),
  'bjcc2022.edlen.com': merge({}, BJCC, { env: ENV.PROD }),
  'bjccootest.edlen.com': merge({}, BJCC, {
    props: getProps(PROPS.BJCC, true),
    env: ENV.TEST,
  }),
  'trainbjcc.edlen.com': merge({}, BJCC, {
    props: getProps(PROPS.BJCC, true),
    env: ENV.TEST,
  }),

  //PROD
  'ordering.edlen.com': merge({}, EDLEN, { env: ENV.PROD }),

  //DEV
  'devoo.edlen.com': merge({}, DEV, {
    theme: 'edlen-dev',
    props: getProps(PROPS.TEST, true),
    env: ENV.DEV,
  }),

  //TEST
  'testoo.edlen.com': merge({}, TEST, {
    theme: 'edlen-test',
    props: getProps(PROPS.TEST, true),
    env: ENV.TEST,
  }),

  //TRAIN
  'trainoo.edlen.com': merge({}, TRAIN, {
    theme: 'edlen-training',
    props: getProps(PROPS.TEST, true),
    env: ENV.TEST,
  }),

  //LocalHost
  localhost: merge({}, DEV, {
    theme: 'edlen-dev',
    props: getProps(PROPS.TEST, true),
    env: ENV.DEV,
  }),

  // Alternate/Legacy IP's
  '72.196.63.173:8010': EDLEN,
  '72.196.63.173:8020': CAJUN,
  '72.196.63.173:8030': BJCC,

  // Default to Edlen, for local development
  default: merge({}, DEV, {
    // theme: 'edlen-dev',
    theme,
    props: getProps(PROPS.TEST, true),
    env: ENV.DEV,
  }),
};

export default SITE;
